import React from "react";
import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

// Section fade + rise on scroll
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Small uppercase eyebrow label
export const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`inline-block text-xs uppercase tracking-[0.35em] font-semibold ${className}`}
  >
    {children}
  </span>
);
